import React from 'react'
import './SocailIconsContainer.css'
function SocialIconsContainer() {
  return (
    <div className='SocialIconsContainer'>
      <a href='https://www.eggheadsclub.io/store' target='_blank'>
      
        <div className='SocialCircles Social-gradient' style={{margin:'0px'}}>
            <img className='SocialImage' src='/assets/Marketplace.png'/>
        
        </div>
        </a>
        <a href='https://opensea.io/collection/eggheadsclub' target='_blank'>
        <div className='SocialCircles'>
            <img className='SocialImage' src='/assets/OpenSea.png'/>
        </div>
        </a>
        <a href='https://discord.com/invite/HTsxXGcwTD' target='_blank'>
        <div className='SocialCircles'>
            <img className='SocialImage' src='/assets/Discord.png'/>
        </div>
        </a>
    </div>
  )
}

export default SocialIconsContainer